import { FormSettingsType } from '../components/Form';
import AppContext from '@services/Context';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
    code: yup.string()
        .min(3, 'DISTRIBUTOR_CODE_MINLENGTH')
        .max(50, 'DISTRIBUTOR_CODE_MAXLENGTH')
        .matches(/^[a-zA-Z0-9]*$/, 'DISTRIBUTOR_CODE_INVALID')
        .required('DISTRIBUTOR_CODE_REQUIRED'),
    name: yup.string()
        .required('REQUIRED')
        .min(3, 'MINLENGTH')
        .max(80, 'MAXLENGTH'),
    email: yup.string()
        .required('REQUIRED')
        .min(3, 'MINLENGTH')
        .email('EMAIL')
})

const validationEditSchema = yup.object().shape({
    code: yup.string()
        .min(3, 'DISTRIBUTOR_CODE_MINLENGTH')
        .max(50, 'DISTRIBUTOR_CODE_MAXLENGTH')
        .matches(/^[a-zA-Z0-9]*$/, 'DISTRIBUTOR_CODE_INVALID')
        .required('DISTRIBUTOR_CODE_REQUIRED'),
    name: yup.string()
        .required('REQUIRED')
        .min(3, 'MINLENGTH')
        .max(80, 'MAXLENGTH')
})


export const DistributorSearchForm: FormSettingsType = {

    submitButtonText: 'form.buttons.search',
    fields: [
        {
            type: 'search',
            name: 'distributorsSearch',
            placeholder: 'form.placeholders.distributorsSearch',
            addorn: {
                rightIcon: 'search',
            },
        },
    ],
};

export const DistributorTableFilterForm: FormSettingsType = {
    submitOnFieldChange: true,
    fields: [
        {
            type: 'buttongroup',
            name: 'status',
            label: 'form.labels.filterDistributorsBy',
            items: [
                { value: 'actives', label: 'form.labels.actives' },
                { value: 'inactives', label: 'form.labels.inactives' },
                { value: 'all', label: 'form.labels.all' },
            ],
            initialValue: 'all',
        },
    ],
};


export const DistributorEditForm: FormSettingsType = {
    validationSchema: validationEditSchema,
    fields: [
        {
            type: 'text',
            className: 'hidden',
            name: 'id',
            label: '',
        },
        {
            type: 'text',
            name: 'code',
            label: 'form.labels.cnpj',
            maxLength: 50,
        },
        {
            type: 'text',
            name: 'name',
            label: 'form.labels.name',
            maxLength: 80,
        }
    ]
}

export const DistributorForm: FormSettingsType = {
    validationSchema: validationSchema,
    fields: [
        {
            type: 'text',
            className: 'hidden',
            name: 'id',
            label: '',
        },
        {
            type: 'text',
            name: 'code',
            label: 'form.labels.cnpj',
            maxLength: 50,
        },
        {
            type: 'text',
            name: 'name',
            label: 'form.labels.name',
            maxLength: 80,
        },
        {
            type: 'email',
            name: 'email',
            label: 'form.labels.email',
        },
        {
            type: 'masked',
            name: 'phone',
            label: 'form.labels.phone',
            labelAddorn: 'form.labels.optional',
            mask: [
                '+',
                /[1-9]/,
                /\d/,
                ' ',
                '(',
                /[1-9]/,
                /\d/,
                ')',
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
            ],
        },
    ],
};
